export default __webpack_public_path__ + "static/media/G89A7810.a421d560.jpg";